export const Select = (
  props: React.SelectHTMLAttributes<HTMLSelectElement> & {
    options: React.OptionHTMLAttributes<HTMLOptionElement>[]
  },
) => {
  return (
    <select {...props}>
      {props.options.map((option, index) => (
        <option
          key={typeof option.value === 'string' ? option.value : index}
          {...option}
          label={option.label || String(option.value)}
        />
      ))}
    </select>
  )
}
